import React from 'react'
import styled from 'styled-components'
const Wrapper = styled.div`
  max-height: ${props => (props.circle ? '15px' : '22px')};
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`
const StyledInput = styled.input`
  opacity: 0;
  position: absolute;
  z-index: 9;
  cursor: pointer;
  &:checked + span {
    background-color: ${props => (props.colorTheme ? props.colorTheme : '#078489')};
    border-color: ${props => (props.colorTheme ? props.colorTheme : '#078489')};
    &:before {
      border-color: ${props => (props.tickColor ? props.tickColor : '#fff')};
    }
  }
  & + span {
    position: relative;
    width: ${props => (props.circle ? '15px' : '20px')};
    height: ${props => (props.circle ? '15px' : '20px')};
    min-width: ${props => (props.circle ? '15px' : '20px')};
    min-height: ${props => (props.circle ? '15px' : '20px')};
    border-radius: ${props => (props.circle ? '50%' : '2px')};
    display: block;
    margin: ${props => (props.flip ? '0 10px 0 0' : '0 0 0 0')};
    border: ${props => (props.circle ? ' 1px solid #e0e0e0' : ' 1px solid #078489')};
    border-radius: 50%;
    z-index: 0;
    transition: 0.2s;
    ${props =>
      props.smallCircle &&
      `
        border: 1px solid #124b5f !important;`};
    &:before {
      content: '';
      width: 8px;
      height: 4px;
      position: absolute;
      border-left: 2px solid transparent;
      border-bottom: 2px solid transparent;
      transform: rotate(-45deg);
      top: 4.5px;
      left: 4px;
      ${props =>
        props.smallCircle &&
        `
        left: 2px !important; 
        top: 3px !important; 

      `};
    }
  }
`
const Label = styled.label`
  display: inline-flex;
  flex-direction: ${props => props.flip && 'row-reverse'};
  align-items: center;
  cursor: pointer;
  & > span:first-child {
    color: ${props => props.labelStyle && props.labelStyle};
  }
`
const Checkbox = ({ circle, label, labelStyle, flip, checked, colorTheme, smallCircle, ...props }) => {
  return (
    <Wrapper circle={circle}>
      <Label circle={circle} flip={flip} labelStyle={labelStyle}>
        <span>{label}</span>
        <StyledInput
          type="checkbox"
          checked={checked}
          circle={circle}
          flip={flip}
          colorTheme={colorTheme}
          smallCircle={smallCircle}
          {...props}
        />
        <span />
      </Label>
    </Wrapper>
  )
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox.js